import { Button } from '@watersport/ui-react-next'
import React from 'react'

import { cn } from 'features/common/helpers/cn'

interface LocationOptionProps {
  Icon: React.ComponentType<{ width: number; height: number; className: string }>
  text: string
  isActive?: boolean
  onClick?: () => void
  showEditButton?: boolean
  dataTestId?: string
}

const LocationOption: React.FC<LocationOptionProps> = ({
  Icon,
  text,
  isActive = false,
  onClick,
  showEditButton = false,
  dataTestId,
}) => (
  <div
    className={cn(
      'flex items-center px-3 py-4 space-x-3 border-b border-blue-200 cursor-pointer',
      isActive && 'border-b-2 border-blue-700',
    )}
    onClick={onClick}
    data-testid={dataTestId}
  >
    <Icon width={24} height={24} className="text-blue-700" />
    <span className="flex-1 text-[15px]">{text}</span>
    {showEditButton && (
      <Button text="Edit" variant="outline" rounded containerClassName="h-8 w-16" />
    )}
  </div>
)

export default LocationOption
